export function isBlank(str) {
  return !str || /^\s*$/.test(str);
}

export function pluralize(count, singular, plural) {
  return count === 1 ? singular : plural || `${singular}s`;
}
